import { useEffect, useState } from "react";
import { usePopup } from "../context/popup";
import { getFlyer } from "../actions/general";
import { SERVER_URL } from "../constants/actionTypes";

export default function PopupFlyers({flyerUrl}) {
  const { isOpen, setIsOpen } = usePopup();
  const [imageUrl, setImageUrl] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const data = await getFlyer()(); // assuming getFlyer() is now a single async function
       console.log(data,"Sdad")
      if (data?.flyer?.image) {
        setImageUrl(data.flyer.image);
      }
    };

    fetchData();
    console.log(imageUrl)
  }, []);

  if (!isOpen || !imageUrl) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center h-screen bg-black bg-opacity-70 z-10">
      <div className="relative">
        <button
          className="absolute top-2 right-2 bg-white rounded-full p-1 shadow-md"
          onClick={() => setIsOpen(false)}
        >
          ✕
        </button>
        <img
          src={SERVER_URL + imageUrl} // remove `/public` if serving from root
          alt="Popup"
          className="max-w-full max-h-screen"
        />
      </div>
    </div>
  );
}
